/*
 * @Description:
 * @Date: 2025-06-10 19:21:04
 */
import { ref } from 'vue';
import { useCloned } from '@vueuse/core';
import { PAY_PASSAGEWAY_MAPPING } from '@constants/bank';
import { IS_ASSISTANT } from '@/config';
import { actOpenInfo } from '../data-source/apis';
import { Bank, ActOpenInfoData } from '../data-source/types';

export const useBank = () => {
  const { offLineBank, ...rest } = useCloned(PAY_PASSAGEWAY_MAPPING).cloned
    .value;
  // 向日葵服务助手仅展示富友支付
  const PAY_PASSAGEWAY = IS_ASSISTANT ? { fyBank: rest.fyBank } : rest;

  const banks = ref<Array<Bank & (typeof PAY_PASSAGEWAY)['fyBank']>>([]);
  const openInfo = ref<ActOpenInfoData>({
    deptId: null,
    entpName: '',
    zbBank: {
      payPassagewayCode: '',
      payPassagewayName: '',
      actOpenStatus: 10,
      platformAuthStatus: 0,
      enabled: 0
    },
    fyBank: {
      payPassagewayCode: '',
      payPassagewayName: '',
      actOpenStatus: 10,
      platformAuthStatus: 0,
      enabled: 0
    }
  });

  const updateBanks = async () => {
    const { data } = await actOpenInfo();
    openInfo.value = data;
    banks.value = Object.values(PAY_PASSAGEWAY).map(item => {
      return {
        ...item,
        /* 默认 */
        actOpenStatus: 10,
        platformAuthStatus: 0,
        enabled: 1,
        /* 覆盖默认 */
        ...data[item.value]
      } as Bank & typeof item;
    });
  };

  return { banks, updateBanks, openInfo };
};
